import { AlkLogger } from '@alk/core';
import { EVENT_DATA_01 } from '../../mocks/limit.event.data';
import { injectable } from 'inversify';
import { ISSEForLimitsService } from './sse-for-limits.interface';

@injectable()
export class SSEForLimitsMock implements ISSEForLimitsService {

    init(): Promise<void> {
        AlkLogger.info('[SSEForLimitsMock#init]');

        return Promise.resolve();
    }

    stop(): void {
        AlkLogger.info('[SSEForLimitsMock#stop]');
    }

    addEventListener(eventType: string, callback: (message?: MessageEvent) => void): void {
        AlkLogger.info('[SSEForLimitsMock#addEventListener]', eventType, callback);

        if (eventType === 'LIMIT_STATUS_UPDATE') {
            const event = new MessageEvent('LIMIT_STATUS_UPDATE', {
                data: EVENT_DATA_01,
            });
            setTimeout(() => callback(event), 600);
        }
    }

    removeEventListener(eventType: string, callback: (message?: MessageEvent) => void): void {
        AlkLogger.info('[SSEForLimitsMock#removeEventListener]', eventType, callback);
    }
}
